var map = {
	"./aquapark/svg_bg.svg": "556a",
	"./aquapark/svg_en.svg": "8862",
	"./banya/svg_bg.svg": "dc18",
	"./banya/svg_en.svg": "16c7",
	"./gallery/svg_bg.svg": "9294",
	"./gallery/svg_en.svg": "b4d9",
	"./gift-voucher/svg_bg.svg": "9ba4",
	"./gift-voucher/svg_en.svg": "f7e6",
	"./gift/svg_bg.svg": "0d8d",
	"./gift/svg_en.svg": "8aeb",
	"./halls/1/svg_bg.svg": "cf23",
	"./halls/1/svg_en.svg": "1b1b",
	"./halls/2/svg_bg.svg": "722f",
	"./halls/2/svg_en.svg": "28b6",
	"./halls/3/svg_bg.svg": "5f64",
	"./halls/3/svg_en.svg": "77d4",
	"./halls/4/svg_bg.svg": "65f2",
	"./halls/4/svg_en.svg": "7c6b",
	"./halls/5/svg_bg.svg": "d789",
	"./halls/5/svg_en.svg": "4f7f",
	"./halls/svg_bg.svg": "4953",
	"./halls/svg_en.svg": "f23e",
	"./kids/svg_bg.svg": "b655",
	"./kids/svg_en.svg": "401e",
	"./loyal/svg_bg.svg": "9dd9",
	"./loyal/svg_en.svg": "403f",
	"./news/svg_bg.svg": "99ec",
	"./news/svg_en.svg": "0d05",
	"./offers/OLD/202200/svg_bg.svg": "ec47",
	"./offers/OLD/202200/svg_en.svg": "da51",
	"./offers/OLD/202201/svg_bg.svg": "8fe5",
	"./offers/OLD/202201/svg_en.svg": "5c72",
	"./offers/OLD/202202/svg_bg.svg": "01b5",
	"./offers/OLD/202202/svg_en.svg": "8467",
	"./offers/OLD/december-escape/svg_bg.svg": "80e8",
	"./offers/OLD/december-escape/svg_en.svg": "9fe8",
	"./offers/OLD/march-escape-2024/svg_bg.svg": "79ce",
	"./offers/OLD/march-escape-2024/svg_en.svg": "e323",
	"./offers/OLD/mountain-relax-2023/svg_bg.svg": "2c7f",
	"./offers/OLD/mountain-relax-2023/svg_en.svg": "dd1d",
	"./offers/OLD/mountain-spa-relax/svg_bg.svg": "46b5",
	"./offers/OLD/mountain-spa-relax/svg_en.svg": "16eb",
	"./offers/OLD/ski-packages-breakfast&dinner-included/svg_bg.svg": "8cbb",
	"./offers/OLD/ski-packages-breakfast&dinner-included/svg_en.svg": "bef3",
	"./offers/OLD/ski-packages-breakfast-included/svg_bg.svg": "a88c",
	"./offers/OLD/ski-packages-breakfast-included/svg_en.svg": "5438",
	"./offers/OLD/yoga-retreat-offer/svg_bg.svg": "a8b2",
	"./offers/OLD/yoga-retreat-offer/svg_en.svg": "3807",
	"./offers/easter-2025/svg_bg.svg": "1a63",
	"./offers/easter-2025/svg_en.svg": "3bac",
	"./offers/mountain-relax-2024/svg_bg.svg": "9eaa",
	"./offers/mountain-relax-2024/svg_en.svg": "3498",
	"./offers/mountain-relax-2025/svg_bg.svg": "5e1d",
	"./offers/mountain-relax-2025/svg_en.svg": "9e00",
	"./offers/mountain-summer-aquapark-2025/svg_bg.svg": "4ee3",
	"./offers/mountain-summer-aquapark-2025/svg_en.svg": "cd7f",
	"./offers/renovation-2025/svg_bg.svg": "fed7",
	"./offers/renovation-2025/svg_en.svg": "af72",
	"./offers/svg_bg.svg": "6985",
	"./offers/svg_en.svg": "33e0",
	"./offers/vipski/svg_bg.svg": "0fae",
	"./offers/vipski/svg_en.svg": "e113",
	"./offers/winter-escape-2025/svg_bg.svg": "8a08",
	"./offers/winter-escape-2025/svg_en.svg": "abac",
	"./restaurant/svg_bg.svg": "e89a",
	"./restaurant/svg_en.svg": "e401",
	"./rooms/1/svg_bg.svg": "0f41",
	"./rooms/1/svg_en.svg": "480f",
	"./rooms/10/svg_bg.svg": "d207",
	"./rooms/10/svg_en.svg": "56c5",
	"./rooms/2/svg_bg.svg": "f435",
	"./rooms/2/svg_en.svg": "4249",
	"./rooms/3/svg_bg.svg": "08c0",
	"./rooms/3/svg_en.svg": "0f05",
	"./rooms/4/svg_bg.svg": "1378",
	"./rooms/4/svg_en.svg": "5bd4",
	"./rooms/5/svg_bg.svg": "ef6e",
	"./rooms/5/svg_en.svg": "362e",
	"./rooms/6/svg_bg.svg": "e2ca",
	"./rooms/6/svg_en.svg": "2119",
	"./rooms/7/svg_bg.svg": "a3d1",
	"./rooms/7/svg_en.svg": "f5cf",
	"./rooms/8/svg_bg.svg": "71f2",
	"./rooms/8/svg_en.svg": "afaf",
	"./rooms/9/svg_bg.svg": "4df5",
	"./rooms/9/svg_en.svg": "3885",
	"./rooms/svg_bg.svg": "1f77",
	"./rooms/svg_en.svg": "683c",
	"./services/svg_bg.svg": "e135",
	"./services/svg_en.svg": "1251",
	"./spa-o/svg_bg.svg": "e9f3",
	"./spa-o/svg_en.svg": "5517",
	"./spa-s/svg_bg.svg": "d27a",
	"./spa-s/svg_en.svg": "f133",
	"./spa-w/svg_bg.svg": "c98a",
	"./spa-w/svg_en.svg": "f58d",
	"./spa/svg_bg.svg": "e1dc",
	"./spa/svg_en.svg": "2f3a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d951";